import { render, staticRenderFns } from "./Wiksa.vue?vue&type=template&id=2ee1fabe&scoped=true&"
import script from "./Wiksa.vue?vue&type=script&lang=js&"
export * from "./Wiksa.vue?vue&type=script&lang=js&"
import style0 from "./Wiksa.vue?vue&type=style&index=0&id=2ee1fabe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee1fabe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCol,VSpacer,VToolbar})
